import {actionHistoryType} from "../../actions/action-history/Type";

const initialState = {
    currentUrl: -1,
    currentTab: undefined,
    unload: false,
    forbidden: false
}

const actionHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionHistoryType.CHANGE_CURRENT_URL:
            return {
                ...state,
                currentUrl: action.currentUrl ?? -1,
                unload: true
            }
        case actionHistoryType.CHANGE_CURRENT_TAB:
            return {
                ...state,
                currentTab: action.currentTab
            }

        case actionHistoryType.CHANGE_CURRENT_ACTION:
            return {
                ...state,
                currentUrl: action.url ?? -1,
                currentTab: action.tab
            }
        case actionHistoryType.CHANGE_UNLOAD_ACTION_HISTORY:
            return {
                ...state,
                unload: action.params
            }
        case actionHistoryType.CHANGE_FORBIDDEN:
            return {
                ...state,
                forbidden: action.params
            }
        default:
            return state;
    }
}
export default actionHistoryReducer;
